var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('page-container',{attrs:{"primary":"","title":_vm.$t('services.categories.neuromarketing.packaging.title'),"intro":"","breadcrumbs":_vm.breadcrumbs}},[_vm._v("\n    Coming soon\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }